module.exports = __webpack_public_path__ + "img/TN_marker_map-Design.4e6e97ea.svg";